import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalData } from '@ui-lib/components';
import { TranslateModule } from '@ngx-translate/core';
import { IHistoryItemModalData } from '../../history.model';

@Component({
  selector: 'mon-history-modal',
  imports: [CommonModule, TranslateModule],
  templateUrl: './history-modal.component.html',
  styleUrl: './history-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoryModalComponent extends ModalData<IHistoryItemModalData> {}
